export const PAID_THROUGH_OPTIONS = [
	{
		value: 'Revolut',
		label: 'Revolut',
	},
	{
		value: 'Wise',
		label: 'Wise',
	},
	{
		value: 'PayPal',
		label: 'PayPal',
	},
	{
		value: 'Swedbank',
		label: 'Swedbank',
	},
	{
		value: 'SEB',
		label: 'SEB',
	},
	{
		value: 'DirectDebit',
		label: 'DirectDebit',
	},
	// `paid_thruogh` values written by the payment gateway.
	{
		value: 'Airwallex Card',
		label: 'Airwallex Card',
	},
	{
		value: 'Apple Pay',
		label: 'Apple Pay',
	},
	{
		value: 'Google Pay',
		label: 'Google Pay',
	},
	{
		value: 'CreditNote',
		label: 'CreditNote',
	},
	{
		value: 'Other',
		label: 'Other',
	},
];
